import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapState } from "pinia";

import config from "../../../../../common/config";
import { useConvertToPendingPal } from "../../store/useConvertToPendingPal";
import { formatPhoneNumber } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import { IGetVendorSlim, IVendor } from "../../../../../resources-vue/vue-interfaces/i-vendor";
import { ITypeaheadOptions } from "../../../../../resources-vue/vue-interfaces/i-typeahead";
import { VendorsService } from "../../../../../services/vendor-service";
import { enumToMap } from "../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { AdvanceDirectives } from "../../../../../enums/ReferralEnums/AdvanceDirectivesEnum";
import { CodeStatus } from "../../../../../enums/ReferralEnums/CodeStatusEnum";

import { PalAdvanceDirectives } from "../../../../../resources-vue/vue-models/palliative-convert-to-pending";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import TypeaheadInput from "../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";
import PlacesAutocomplete from "../../../../../resources-vue/vue-custom-elements/PlacesAutocomplete/PlacesAutocomplete.vue";
import StateTypeahead from "../../../../../resources-vue/vue-custom-elements/StateTypeahead/StateTypeahead.vue";

export default defineComponent({
    components: {
        FormSection,
        TypeaheadInput,
        PlacesAutocomplete,
        StateTypeahead
    },

    data() {
        return {
            _vendorsService: null,
            _redirectURL: null,
            selectedVendor: null,
            selectedState: null,
            AdvanceDirectivesEnum: AdvanceDirectives,
            CodeStatusEnum: CodeStatus,
            formatPhoneNumber,
            enumToMap
        };
    },

    computed: {
        ...mapState(useConvertToPendingPal, ["patientDetails", "application", "accountId", "patientOptions"])
    },

    created() {
        this._vendorsService = Container.instance.get(VendorsService);
        this._redirectURL = `${config.palliativeUrl}/create/vendor`;
        if (!this.patientDetails?.advanceDirectives) {
            this.patientDetails.advanceDirectives = new PalAdvanceDirectives();
        }
        if (!this.patientDetails?.advanceDirectives?.patientFuneralHome) {
            this.patientDetails.advanceDirectives.patientFuneralHome = {
                id: "",
                name: "",
                address: "",
                city: "",
                state: "",
                zipCode: "",
                phoneNumber: "",
                afterHrsPhoneNumber: ""
            };
        }
    },

    watch: {
        selectedState(newValue, oldValue) {
            if (newValue == oldValue) {
                return;
            }
            if (!!this.selectedState) {
                this.patientDetails.advanceDirectives.patientFuneralHome.state = this.selectedState.value;
            } else {
                this.patientDetails.advanceDirectives.patientFuneralHome.state = "";
            }
        }
    },

    methods: {
        handleAdvDirectivesSelection(value: number) {
            if (this.patientDetails.advanceDirectives.advancedDirectives.advancedCarePlanDirectives.includes(value)) {
                this.patientDetails.advanceDirectives.advancedDirectives.advancedCarePlanDirectives =
                    this.patientDetails.advanceDirectives.advancedDirectives.advancedCarePlanDirectives.filter(
                        (val: number) => val !== value
                    );
            } else {
                this.patientDetails.advanceDirectives.advancedDirectives.advancedCarePlanDirectives.push(value);
            }
        },

        handleCodeStatusSelection(value: number) {
            if (this.patientDetails.advanceDirectives.advancedDirectives.codeStatus.includes(value)) {
                this.patientDetails.advanceDirectives.advancedDirectives.codeStatus =
                    this.patientDetails.advanceDirectives.advancedDirectives.codeStatus.filter(
                        (val: number) => val !== value
                    );
            } else {
                this.patientDetails.advanceDirectives.advancedDirectives.codeStatus.push(value);
            }
        },

        async getVendorList(filter: string, limit: number) {
            const payload = {
                accountId: this.accountId,
                name: filter,
                providerIds: [this.patientOptions.data.providerId],
                application: this.application
            };
            let vendorsList = await this._vendorsService.getVendorByTerm(payload);
            return this.vendorResToTypeahead(vendorsList);
        },

        vendorResToTypeahead(vendors: IGetVendorSlim[]): ITypeaheadOptions[] {
            return vendors.map((vendor) => ({
                name: vendor.name,
                value: vendor.id
            }));
        },

        async updateVendor(vendor: any) {
            this.selectedVendor = vendor;
            const payload = {
                id: vendor.value,
                accountId: this.accountId,
                application: this.application
            };
            let vendorDetails: IVendor = await this._vendorsService.getVendorById(payload);
            this.patientDetails.advanceDirectives.patientFuneralHome.name = vendorDetails.name;
            this.patientDetails.advanceDirectives.patientFuneralHome.address = vendorDetails.address.addressLine1;
            this.patientDetails.advanceDirectives.patientFuneralHome.city = vendorDetails.address.city;
            this.patientDetails.advanceDirectives.patientFuneralHome.state = vendorDetails.address.state;
            this.patientDetails.advanceDirectives.patientFuneralHome.zipCode = vendorDetails.address.zipCode;
        },

        valueUpdated(value: string, type?: string) {
            let number =
                value
                    .split("")
                    ?.map((item) => (Number(item) || item == "0" ? item : ""))
                    .join("") || "";

            if (type == "primary") {
                this.patientDetails.advanceDirectives.patientFuneralHome.phoneNumber = number;
            } else {
                this.patientDetails.advanceDirectives.patientFuneralHome.afterHrsPhoneNumber = number;
            }
        },

        openAddDocumentModal() {
            // will be implemented in a separate ticket
        }
    }
});
